module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-introduction element-without-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Don’t miss book two of the Love Beyond Danger series with "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://smarturl.it/UncoveredCO",
      "target": "_blank"
    }
  }, [_vm._v("LOVE UNCOVERED")]), _vm._v(" and discover more from Diane Holiday at "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.dianeholiday.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.dianeholiday.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://smarturl.it/uncoveredco",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Love Uncovered",
      "src": "images/love-uncovered-3d.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Free-spirited Maddie Cooper never considered settling down—until Scott Fisher came into her life. But after her DEA agent left with nothing more than a broken promise, Maddie dug in deep with her first love: archaeology.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("She’s unearthed significant Native American artifacts at a site in the Finger Lakes, but a break-in at the storage facility jeopardizes everything. To make matters worse, the new detective assigned to the case is none other than DEA Agent Scott. As if the burglary and Scott’s reappearance isn’t enough, a ruthless developer has moved into town, and he wants Maddie to falsify her survey results. Deeply committed to the preservation of history, she’s determined to bring down the developer without any help, least of all from her former lover.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("After a tragic loss, Scott gave up on all the things that brought light to his life, including Maddie. He doesn’t want her anywhere near the dark, dangerous world of his undercover job. But their worlds collide when Maddie secretly decides to take on Victor Mole. She has no idea Mole is a brutal drug lord and artifact smuggler. With time running out on Maddie’s survey, and her life at stake, if Scott can’t find a way to protect her, he risks all he’s worked for and the only woman he’s ever loved.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://smarturl.it/UncoveredCO",
      "target": "_blank"
    }
  }, [_vm._v("BUY NOW!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117f7580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/keepreadinglovebeyonddangerseries.vue
// module id = 81
// module chunks = 0